import { getReviewCsvExport } from '@/api';
import { downloadBlob, filenameFromContentDisposition } from '@/utils/download';
import { safeStringify } from '@/utils/jsonHelpers';

/** The server-rendered CSV of a whole review: every file row × every prompt column. */

/** Options for the whole-review CSV — each one adds a column group server-side. */
export interface ReviewCsvOptions {
  include_prompt: boolean;
  include_evaluation: boolean;
  include_reasons: boolean;
}

/**
 * Download the server-rendered CSV of a whole review (every file × every
 * prompt). Prefers the file name the server sets in `Content-Disposition`.
 */
export async function downloadReviewCsv(
  reviewUid: string,
  options: ReviewCsvOptions,
  fallbackName: string
): Promise<void> {
  const response = await getReviewCsvExport({
    path: { review_uid: reviewUid },
    query: options,
    parseAs: 'blob',
  });

  const responseData = 'data' in response ? response.data : response;
  const blob =
    responseData instanceof Blob
      ? responseData
      : new Blob([responseData ? safeStringify(responseData) : ''], {
          type: 'text/csv;charset=utf-8;',
        });

  const serverName = response.response
    ? filenameFromContentDisposition(response.response.headers.get('Content-Disposition'))
    : null;

  downloadBlob(blob, serverName ?? fallbackName);
}
